export default "__VITE_ASSET__Dxby5NgL__"